import ListItem from '../presents/ListItem'

const ListItemWeischerContainer = ({
    itemType,
    itemData,
    additionalClass,
    isSelected,
    pathnameEdit,
    onDelete,
}) => {
    const { payload } = itemData

    const title = 'Weischer ' + payload

    const styles = {
        border: 'none'
    }

    return <ListItem
        title={title}
        styles={styles}
        type={itemType}
        additionalClass={additionalClass}
        isSelected={isSelected}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

export default ListItemWeischerContainer